<ng-container
    #paymentSystemsIcons="icons"
    category="payment_systems"
    lsIcons
>
    <ng-container
        *ngTemplateOutlet="paymentsSwiper; context: {
            payments: paymentSystemsIcons.items$(),
        }"
    />
</ng-container>

<ng-template
    #paymentsSwiper
    let-payments="payments"
>
    <div
        class="payments-slider__container"
        [class._swiper-is-end]="swiperIsEnd"
        [class._swiper-is-start]="swiperIsStart"
    >
        <swiper-container
            #swiperContainer
            init="false"
        >
            @for (item of payments; track item.icon_id) {
                <swiper-slide class="payments-slider__slide">
                    <picture class="payments-slider__item">
                        <img
                            class="payments-slider__img"
                            height="52"
                            loading="lazy"
                            width="104"
                            [alt]="item.title"
                            [src]="item.image"
                        >
                    </picture>
                </swiper-slide>
            }
        </swiper-container>
    </div>
</ng-template>
